import React from "react"
import axios from "axios"
import Button from "@material-ui/core/Button"

import { checkTokenExpirationMiddleware } from "../middlewares/users-auth.middleware"

const defaultUploadState = {
  blobPath: null,
  originalFileName: "",
  error: null,
  uploading: false
}

export const createUploadState = overrides => ({
  ...defaultUploadState,
  ...overrides
})

export const getUploadErrorMessage = error => {
  if (error && error.response && typeof error.response.data === "string") return error.response.data
  if (error && error.response && error.response.data && error.response.data.message) return error.response.data.message

  return "File upload failed."
}

export const normalizeAttachmentPath = attachment => {
  if (!attachment || typeof attachment !== "string") return null

  const trimmedAttachment = attachment.trim()
  if (trimmedAttachment === "") return null

  const normalizedAttachment = trimmedAttachment.replace(/\\/g, "/")
  const attachmentsMarker = "/Attachments/"
  const markerIndex = normalizedAttachment.toLowerCase().lastIndexOf(attachmentsMarker.toLowerCase())

  let pathValue = markerIndex >= 0
    ? normalizedAttachment.substring(markerIndex + attachmentsMarker.length)
    : normalizedAttachment.replace(/^\/+/, "")

  pathValue = pathValue
    .split("/")
    .filter(Boolean)
    .join("/")

  if (pathValue === "") return null

  const segments = pathValue.split("/")
  if (segments.length > 0) {
    const firstSegment = segments[0].toLowerCase()
    segments[0] = firstSegment === "std" ? "standalone" : firstSegment
  }

  return segments.join("/")
}

export const getAttachmentName = attachment => {
  const normalizedPath = normalizeAttachmentPath(attachment)
  if (!normalizedPath) return ""

  const segments = normalizedPath.split("/")
  return segments[segments.length - 1]
}

export const uploadPrivateFile = async ({ file, category, token }) => {
  const formData = new FormData()
  formData.append("file", file)
  formData.append("category", category)

  const response = await axios.post("/api/files/upload/private", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "multipart/form-data"
    }
  })

  return response.data
}

export const uploadSelectedFile = async ({ file, category, token, setUploadState }) => {
  if (!file) {
    setUploadState(createUploadState())
    return
  }

  setUploadState(createUploadState({ uploading: true }))

  try {
    const uploadResult = await uploadPrivateFile({ file, category, token })
    setUploadState(createUploadState({
      blobPath: uploadResult.blobPath,
      originalFileName: uploadResult.originalFileName
    }))
  } catch (error) {
    setUploadState(createUploadState({
      error: getUploadErrorMessage(error)
    }))
  }
}

export const openPrivateAttachment = async attachment => {
  const normalizedPath = normalizeAttachmentPath(attachment)
  const user = checkTokenExpirationMiddleware()

  if (!normalizedPath || !user || !user.Token) {
    return
  }

  try {
    const response = await axios.get("/api/files/download", {
      params: { path: normalizedPath },
      headers: {
        Authorization: `Bearer ${user.Token}`
      }
    })

    if (response.data && response.data.url) {
      window.open(response.data.url, "_blank", "noopener,noreferrer")
    }
  } catch (error) {
    window.alert("Unable to download this attachment right now.")
  }
}

export const renderAttachment = attachment => {
  const attachmentName = getAttachmentName(attachment)

  return attachmentName
    ? (
      <Button
        color="primary"
        size="small"
        onClick={() => openPrivateAttachment(attachment)}
      >
        {attachmentName}
      </Button>
    )
    : "-"
}
